import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-training-tools',
  templateUrl: './training-tools.page.html',
  styleUrls: ['./training-tools.page.scss'],
})
export class TrainingToolsPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
